<template lang="pug">
  .container.grid-lg.py-2
    loading.v-loading(:loading='loading')
    .card(v-if='legislacao')
      .card-body
        .form-group
          label.form-label(for='titulo') {{ 'legislacao.titulo' | tModel }}
          input.form-input#titulo(type='text' v-model='legislacao.titulo')
        .form-group
          label.form-label(for='descricao') {{ 'legislacao.descricao' | tModel }}
          input.form-input#descricao(type='text' v-model='legislacao.descricao')
        .form-group
          show-anexo(:anexo='legislacao.anexo')
          modal-anexo(ref="modalAnexo" @saveAnexo='onSaveAnexo' title="Anexo")
          a.btn.btn-link(@click='() => $refs.modalAnexo.open(legislacao.anexo)')
            btn-content(name='edit' label='Anexar arquivo')
      .card-footer.text-right
        button.btn.btn-primary(:class="{'loading': loading}", @click='save', :disabled='loading')
          btn-content(name='save')
</template>

<script>
import ShowAnexo from "./anexos/ShowAnexo"
import ModalAnexo from "./anexos/ModalAnexo"

export default {
  vuex: {
    "sistema/legislacoes": {
      actions: ["fetchCreate"],
      getters: ["loading"],
    },
  },
  components: { ModalAnexo, ShowAnexo },
  data() {
    return { legislacao: {} }
  },
  methods: {
    toggle(value) {
      if (this.tree) {
        this.tree.toggleAll(value)
      }
    },
    save() {
      this.fetchCreate(this.legislacao)
        .then(res => {
          this.$toaster.success("Salvo com sucesso.")
          this.$router.push({ name: "app.sistema.legislacoes" })
        })
        .catch(e => {
          this.$toaster.error(e.message)
        })
    },
    onSaveAnexo(anexo) {
      this.$set(this.legislacao, "anexo", anexo)
    },
  },
}
</script>
